import {graphql} from "relay-runtime";

export const localCartLandImpulseQuery =  graphql`
    query graphqlLandImpulseQuery($request: LandRequestInput) {
        landImpulse(request: $request) {
            lands {
                pickExs {
                    index
                }
            }
            solves {
                amount
                serviceFeeAmount
            }
        }
    }
`;